@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-1">
        <!-- Seletor de papel -->
        @if ($shouldLetPublicAgentInteract() && $hasPendingTask() && $papeisSelector().length > 0) {
            <papel-selector [_signerId]="$inputData().eDocsData.signerId"
                            [_isReadOnly]="$isReadOnly()"
                            [_papeis]="$papeisSelector()"
                            [_flowObjectType]="FlowObjectType.TaskAcknowledge"
                            (_signerIdChange)="signerIdChange($event)"
            ></papel-selector>
            <hr />
        }

        <!-- Task body: visão do executor -->
        @if ($previousDocuments().length > 0 && $shouldLetPublicAgentInteract()) {
            <div class="message-container">
                <div>Conteúdo avaliado:</div>

                <div class="documents-container">
                    @for (doc of $previousDocuments(); track doc) {
                        <div class="position-relative my-1">
                            <span class="document-highlight" (click)="openDocumentModal(doc.id)" (keyDown)="openDocumentModal(doc.id)">
                                <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do documento">{{doc.registro}}</span>
                                <span class="info-font d-inline-block" matTooltip="Clique para visualizar o documento que foi capturado no E-Docs">
                                    <i class="fas fa-external-link-alt mr-2"></i><u>{{doc.filename}}</u>
                                </span>
                            </span>
                        </div>
                    }
                </div>

                <hr />
            </div>
        }

        <!-- Task info: Realizada -->
        @if (!$hasPendingTask()) {
            <div class="message-container">
                <div class="mb-3">
                    O conteúdo disponível no Encaminhamento E-Docs de protocolo
                    <span class="info-font text-highlight">{{$forwardingProtocol()}}</span>

                    @if ($processProtocol() != Enums.Messages.DefaultEmptyValue) {
                        <span>
                            e no Processo E-Docs de protocolo
                            <span class="info-font text-highlight">{{$processProtocol()}}</span>
                        </span>
                    }

                    foi <b>apreciado</b> por:
                </div>
                <div class="mb-3">
                    <span class="uppercase info-font text-highlight d-inline-block">{{$recipient()}}</span>
                </div>
                <hr />
                <div class="mb-3">
                    A seguinte mensagem foi fornecida:
                </div>
                <div>
                    <i class="document-highlight info-font">{{$inputData().message}}</i>
                </div>

                @if ($shouldLetPublicAgentInteract()) {
                    <hr />
                    <div class="mb-3">
                        Documento{{$hasAttachments() ? 's' : ''}} comprobatório{{$hasAttachments() ? 's' : ''}} da realização desta Tarefa:
                    </div>
                    <div class="documents-container">
                        @for (doc of $currentDocuments(); track doc) {
                            <div class="position-relative my-1">
                                <span class="document-highlight" (click)="openDocumentModal(doc.id)" (keyDown)="openDocumentModal(doc.id)">
                                    <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do documento">{{doc.registro}}</span>
                                    <span class="info-font d-inline-block" matTooltip="Clique para visualizar o documento que foi capturado no E-Docs">
                                        <i class="fas fa-external-link-alt mr-2"></i><u>{{doc.filename}}</u>
                                    </span>
                                </span>
                            </div>
                        }
                    </div>
                } @else if ($hasAttachments()) {
                    <hr />
                    <div class="mb-3">
                        Anexo{{$isPlural() ? 's' : ''}} fornecido{{$isPlural() ? 's' : ''}} na realização desta Tarefa:
                    </div>
                    <div class="documents-container">
                        @for (doc of $attachmentDocuments(); track doc) {
                            <div class="position-relative my-1">
                                <span class="document-highlight" (click)="openDocumentModal(doc.id)" (keyDown)="openDocumentModal(doc.id)">
                                    <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do documento">{{doc.registro}}</span>
                                    <span class="info-font d-inline-block" matTooltip="Clique para visualizar o documento que foi capturado no E-Docs">
                                        <i class="fas fa-external-link-alt mr-2"></i><u>{{doc.filename}}</u>
                                    </span>
                                </span>
                            </div>
                        }
                    </div>
                }
            </div>
        } @else {
            <!-- Task info: Iniciada -->
            @if (!$shouldLetPublicAgentInteract()) {
                <!-- Task body: visão do requerente -->
                <div class="message-container">
                    <div class="mb-3">
                        Conteúdo do Encaminhamento E-Docs de protocolo
                        <span class="info-font text-highlight">{{$forwardingProtocol()}}</span>

                        @if ($processProtocol() != Enums.Messages.DefaultEmptyValue) {
                            <span>
                                e do Processo E-Docs de protocolo
                                <span class="info-font text-highlight">{{$processProtocol()}}</span>
                            </span>
                        }

                        em apreciação por:
                    </div>
                    <div>
                        <span class="uppercase info-font text-highlight d-inline-block">{{$recipient()}}</span>
                    </div>

                    @if (Utils.isNotNullOrEmpty($publicMessageHtml())) {
                        <hr />
                        <div class="public-message py-1"
                             [class.loading]="$isPublicMessageHtmlLoading()"
                             [safeHtmlContent]="$publicMessageHtml()"
                        >{{Enums.Messages.DefaultLoadingText}}</div>
                    }
                </div>
            } @else {
                <!-- Task footer: visão do executor -->
                <div class="form-container">
                    <span><span style="color: red">*</span> Parecer sobre o conteúdo acima relacionado:</span>

                    <div class="input-container text-center mt-1 mb-3 px-0">
                        <textarea id="message" placeholder="Entre com a mensagem de registro de ciência" rows="4"
                                    [class.minlength]="$isMissingMessage()"
                                    [ngModel]="$inputData().message"
                                    (change)="onChangeMessage($event.target.value)"
                        ></textarea>
                    </div>

                    <div class="footer">
                        @if ($hasAttachments()) {
                            <button type="button" class="btn"
                                    [ngClass]="$isMarkedForAcknowledgement() ? 'btn-primary' : 'btn-outline-primary'"
                                    (click)="toggleMarkForAcknowledgement()"
                                    (keyDown)="toggleMarkForAcknowledgement()"
                            >Prosseguir</button>
                        } @else {
                            <button type="button" class="btn btn-outline-primary" (click)="submit()" (keyDown)="submit()">Prosseguir</button>
                        }
                    </div>

                    @if ($hasAttachments() && $isMarkedForAcknowledgement()) {
                        <hr class="mt-3"/>

                        <div class="mb-3">
                            <span>Forneça </span>

                            @if ($isPlural()) {
                                <span>os documentos anexos configurados</span>
                            } @else {
                                <span>o documento anexo configurado</span>
                            }

                            <span> para captura no E-Docs ao se executar esta Tarefa:</span>
                        </div>

                        <div class="attachments-container mb-3">
                            @for (item of $configSchema()?.taskAcknowledge?.extraContent?.attachments; track item) {
                                <div class="attachment-row">
                                    <div class="attachment-info">
                                        <span class="title">{{item.label}}</span>
                                        <span class="label">Valor Legal</span>
                                        <span class="value">{{getDocumentLegalValueCombination(item)}}</span>
                                        <span class="label">Classificação Documental</span>
                                        <span class="value">{{item.documentClass.name}}</span>
                                        <span class="label">Nível de Acesso</span>
                                        <span class="value">{{item.accessLevel.name}}</span>

                                        @if (item.accessLevel.legalReasoningsNames?.length > 0) {
                                            <span class="label">Fundamentação Legal</span>
                                            <span class="value">{{getLegalReasoningsNames(item)}}</span>
                                        }
                                    </div>

                                    <pdf-upload (valueChange)="onPdfUploadChange($event, item)"></pdf-upload>
                                </div>
                            }
                        </div>

                        <div class="footer">
                            <button type="button" class="btn btn-outline-success" (click)="submit()" (keyDown)="submit()">Enviar</button>
                        </div>
                    }
                </div>
            }
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
